import { render, staticRenderFns } from "./GlobalNotice.vue?vue&type=template&id=32cb2871&scoped=true"
import script from "./GlobalNotice.vue?vue&type=script&lang=js"
export * from "./GlobalNotice.vue?vue&type=script&lang=js"
import style0 from "./GlobalNotice.vue?vue&type=style&index=0&id=32cb2871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb2871",
  null
  
)

export default component.exports